// @flow
import { View } from "extensions/marionette";
import $ from "jquery";
import { getDecimalSeparator } from "common/utils";
import strings from "common/strings";
import Cleave from "cleave.js";

import template from "./amountPicker.jst";
import "./amountPicker.scss";

const RANGE_DELIMITER = ":";

export const AmountPicker = View.extend({
    className: "amount-picker",
    template,
    mode: "exact",
    regions: {
        dd: ".amount-type"
    },
    ui: {
        lower: ".lower-limit-input",
        upper: ".upper-limit-input",
        amount: ".amount-inputs .val"
    },
    
    events: {
        "keyup input.lower-limit-input, input.upper-limit-input": "setValue",
        "change input.lower-limit-input, input.upper-limit-input": "setValue",
        "click .toggle-amount-type input": "toggleRange",
        "click .clear-amount-icon": "clearAmount"
    },
    
    toggleRange(e) {
        e.stopPropagation();
        this.mode = e.currentTarget.dataset.type;
        this.$el.toggleClass("range", this.mode === "range");
        if (this.mode === "exact") {
            this.ui.upper.val("");
            const placeHolder = `0${this.constructor.decimalInfo.holder}00`;
            this.ui.lower[0].setAttribute("placeholder", placeHolder);
        } else {
            this.ui.lower[0].setAttribute("placeholder", "No lower limit");
        }
    },
    
    getValue() {
        const instanceValue = this.getOption("value");
        
        if (typeof instanceValue === "string" && instanceValue.length) {
            return instanceValue;
        }
        
        return "";
    },
    
    renderCurrencyPicker() {
        if (this.getOption("dropDown")) {
            this.addRegion("currency_picker", `.${this.getOption("pickerRoot")}currency`);
            this.showChildView("currency_picker", this.getOption("dropDown"));
        }
    },
    
    parseValueAndDisplay() {
        const passedInAmount = this.getValue();
        if (!passedInAmount) { return; }
    
        // If amount is range
        if (passedInAmount.includes(RANGE_DELIMITER)) {
            this.mode = "range";
            const [lowerVal = "", upperVal = ""] = passedInAmount.split(RANGE_DELIMITER);
        
            const localLowerVal = lowerVal.replace(".", this.constructor.decimalInfo.holder);
            const localUpperVal = upperVal.replace(".", this.constructor.decimalInfo.holder);
        
            if (lowerVal) {
                // Presentation layer should display local decimal separator for the lower value
                this.ui.lower.val(localLowerVal);
            }
            if (upperVal) {
                // Presentation layer should display local decimal separator for the lower value
                this.ui.upper.val(localUpperVal);
            }
        } else {
            this.ui.lower.val(passedInAmount.replace(".", this.constructor.decimalInfo.holder));
        }
    },
    
    clearAmount(e) {
        const el = $(e.currentTarget).parent().find("input");
        el.val("");
        this.setValue();
    },
    
    setValue() {
        const lowerVal = this.lowerBound.getRawValue();
        const upperVal = this.upperBound.getRawValue();
        this.ui.lower.parent().find(".clear-amount-icon").toggleClass("hasval", lowerVal !== "");
        this.ui.upper.parent().find(".clear-amount-icon").toggleClass("hasval", upperVal !== "");
        if (this.mode === "exact") {
            this.ui.amount.val(lowerVal);
            this.ui.amount.trigger("change");
        } else if (lowerVal || upperVal) {
            const range = `${lowerVal}${RANGE_DELIMITER}${upperVal}`;
            this.ui.amount.val(range);
            this.ui.amount.trigger("change");
        } else if (lowerVal === "" && upperVal === "") {
            this.ui.amount.val("");
            this.ui.amount.trigger("change");
        }
    },
    
    onRender() {
        this.renderCurrencyPicker();
        this.parseValueAndDisplay();
        this.$el.toggleClass("range", this.mode === "range");
    
        this.lowerBound = new Cleave(this.ui.lower[0], {
            numeral: true,
            numeralDecimalMark: this.constructor.decimalInfo.holder,
            numeralDecimalScale: 2,
            delimiter: this.constructor.decimalInfo.cleanWhat
        
        });
        this.upperBound = new Cleave(this.ui.upper[0], {
            numeral: true,
            numeralDecimalMark: this.constructor.decimalInfo.holder,
            numeralDecimalScale: 2,
            delimiter: this.constructor.decimalInfo.cleanWhat
        });
    },
    
    templateContext() {
        const passedInAmount = this.getValue();
        const splitAmount = passedInAmount ? passedInAmount.split(":") : [];
        const isRange = passedInAmount.includes(RANGE_DELIMITER);
        const isExact = !isRange;
        return {
            isRange,
            isExact,
            pickerRoot: this.getOption("pickerRoot"),
            inputval: this.getValue(),
            showClearLower: splitAmount[0] ? "hasval" : "",
            showClearUpper: splitAmount[1] ? "hasval" : "",
            decimalSeparator: this.constructor.decimalInfo.holder,
            amountLabel: this.getOption("label") || strings.amount
        };
    },
    onDestroy() {
        if (this.upperBound) {
            this.upperBound.destroy();
        }
        
        if (this.lowerBound) {
            this.lowerBound.destroy();
        }
    }
}, {
    decimalInfo: getDecimalSeparator()
});
